import { createSlice, createEntityAdapter } from '@reduxjs/toolkit';

import { QuizType } from '@/modules/types/quiz';

export const quizAdapter = createEntityAdapter();

const initialState: QuizType = quizAdapter.getInitialState({
  isLoaded: false,
  isLoading: false,
  data: null,
  currentQuestionNo: 1,
  result: null,
  quizStart: false,
});

const quizSlice = createSlice({
  name: 'quiz',
  initialState,
  reducers: {
    fetchSuccess: (state, action) => {
      state.isLoaded = true;
      state.isLoading = false;
      state.data = action.payload;
      state.quizStart = true;
    },
    postResult: (state) => {
      state.isLoading = true;
    },
    submitQuizResultSuccess: (state, action) => {
      state.isLoading = false;
      state.isLoaded = true;
      state.result = action.payload;
    },
    resetResult: (state, action) => {
      state.result = null;
    },
  },
});

export const { name, actions, reducer } = quizSlice;
